<template>
    <fox-page :class="$style.root" :disabled="disabled" :readonly="readonly">
        <slot></slot>
        <s-empty v-if="(!$slots.default) && $env.VUE_APP_DESIGNER && !!$attrs['vusion-node-path']"></s-empty>
    </fox-page>
</template>

<script>
export default {
    name: 'md-page',
    props: [ 'disabled', 'readonly' ],
};
</script>

<style module>
.root {
}
</style>
